















import { Vue, Component, Prop } from 'nuxt-property-decorator';
import UniversalSearchResultsItem from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsItem.vue';
import EditIcon from '@/components/common/UniversalSearch/images/edit-post.vue.svg';
import type { Article } from '@/types/graphql';

@Component<UniversalSearchResultsArticle>({
  components: {
    UniversalSearchResultsItem,
    EditIcon,
  },
})
export default class UniversalSearchResultsArticle extends Vue {
  @Prop({ default: false }) removable!: boolean;
  @Prop({ required: true }) item!: { article: Article };
  protected imageFailed = false;

  get title() {
    return this.item.article.title;
  }

  get description() {
    const name = this.item.article.author?.name;
    return name ? `Posted by ${name}` : '';
  }

  get image() {
    return this.imageFailed ? undefined : this.item.article.previewImage?.url;
  }

  handleError() {
    this.imageFailed = true;
  }
}
